import React from 'react';
import styled from 'styled-components';

function RadioButtonsHorizontal({id, label, question, values, onChange, invalid}) {
  const name = id ? id : `answer-${question.id}`;
  const selected = values.length > 0 ? values[0] : '';
  return (
    <FieldContainer invalid={invalid}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <Options role="radiogroup" aria-labelledby={label ? name : undefined}>
        {question.questionOptions.map(option => {
          const checked = selected === option.value;
          return (
            <Option key={option.value}>
              <input
                type="radio"
                id={`${name}-${option.value}`}
                name={name}
                value={option.value}
                checked={checked}
                onChange={e => onChange([e.target.value], true)}
              />
              <span>{option.value}</span>
            </Option>
          );
        })}
      </Options>
      {invalid && <ValidationText>{invalid}</ValidationText>}
    </FieldContainer>
  );
}

const FieldContainer = styled.div`
  margin: 0 0 1rem 0;
`;

const Label = styled.label`
  display: block;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;

const Options = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 0.25rem;
`;

const Option = styled.label`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  white-space: nowrap;
  gap: 0.35rem;

  input[type=radio] {
    margin: 0;
  }
`;

const ValidationText = styled.div`
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default RadioButtonsHorizontal;
